import { useState } from "react"
import {
    AppBar,
    Tabs,
    Tab,
    Paper,
    Typography,
    Grid,
    Box,
} from "@material-ui/core"
import { useSelector } from "react-redux"
import { useContratacion } from "../../../hooks/useContratacion"
import { formatDinero } from "../../../utils/formatDinero"
import { FormatoFechaIso } from "../../../utils/FormatFecha"

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div>
                    {children}
                </div>
            )}
        </div>
    );
}
function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        "aria-controls": `scrollable-force-tabpanel-${index}`,
    };
}
function agruparPorTipoSuplemento(array) {
    return array.reduce((resultado, item) => {
        const tipo = item.TipoSuplemento;

        if (!resultado[tipo]) {
            resultado[tipo] = [];
        }

        resultado[tipo].push(item);
        return resultado;
    }, {});
}
function obtenerTipoExtra(nombre) {
    if (!nombre) return null;

    const nombreLower = nombre.toLowerCase();

    if (nombreLower.includes("equipaje")) return "- Equipaje";
    if (nombreLower.includes("desayuno")) return "- Desayuno";
    if (nombreLower.includes("tour")) return "- Tour";

    return "";
}
export const TapViaje = () => {
    const { referencia } = useSelector(store => store.cliente)
    const [contratacion] = useContratacion({ referencia })
    const extrasPaquete = contratacion.PaqueteContratado?.ListaSuplementoContratado ?? []
    const extrasAgrupados = agruparPorTipoSuplemento(extrasPaquete);
    const tiposUnicos = [...new Set(extrasPaquete.map(extra => extra.TipoSuplemento))];
    const [value, setValue] = useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    }
    return (
        <>
            <AppBar position="static" color="primary">
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="on"
                    indicatorColor="primary"
                    aria-label="scrollable force tabs example"
                >
                    {
                        tiposUnicos.map((tipo, index) => (
                            <Tab
                                key={index}
                                label={tipo}
                                {...a11yProps(index)}
                                value={index}
                            />
                        ))
                    }
                </Tabs>
            </AppBar>
            {tiposUnicos.map((tipo, index) => (
                <TabPanel key={index} value={value} index={index}>
                    <Grid container spacing={2}>
                        {extrasAgrupados[tipo].map(extra => (
                            <Grid item xs={12} md={6} key={extra.IdExtraPaqueteProveedor}>
                                <Paper elevation={3} style={{ padding: "16px" }}>
                                    <Typography variant="h6" gutterBottom>
                                        {`${extra?.TipoSuplemento} ${obtenerTipoExtra(extra.Nombre)}`}
                                    </Typography>

                                    <Grid container spacing={1}>
                                        <Grid item xs={6}>
                                            <Typography variant="body2"><strong>Cantidad:</strong> {extra?.Cantidad}</Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="body2">
                                                <strong>Precio:</strong> {formatDinero(extra?.Precio)} {contratacion?.Moneda}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="body2">
                                                <strong>Total:</strong> {formatDinero(extra?.Precio * extra?.Cantidad)} {contratacion?.Moneda}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="body2">
                                                <strong>Fecha:</strong> {FormatoFechaIso({ date: extra?.FechaRegistro, formato: "dd/MM/yyyy" })}
                                            </Typography>
                                        </Grid>
                                    </Grid>

                                    <Box mt={2}>
                                        <Typography variant="subtitle2"><strong>Nombre suplemento:</strong></Typography>
                                        <Box pl={1} dangerouslySetInnerHTML={{ __html: extra?.Nombre }} />
                                    </Box>

                                    <Box mt={1} pl={1}>
                                        <div dangerouslySetInnerHTML={{ __html: extra?.Descripcion ?? "" }} />
                                    </Box>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </TabPanel>
            ))}
        </>
    )
}